export const storeItem = (key: string, value: string) => {
  localStorage.setItem(key, value);
};

export const getItem = (key: string) => {
  return localStorage.getItem(key);
};

export const removeItem = (key: string) => {
  localStorage.removeItem(key);
};

export const storeJSON = (key: string, data: any) => {
  localStorage.setItem(key, JSON.stringify(data));
};

export const getJSON = (key: string) => {
  const stringi = localStorage.getItem(key);
  return stringi ? JSON.parse(stringi) : null;
};
